import React from 'react';
import './App.css';
import AppRouter from './Configure/AppRouter';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Navbar />
      <main className="site-shell">
        <AppRouter />
      </main>
      <Footer />
    </LanguageProvider>
  );
}

export default App;
